import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React from "react";
import { getProblematicTreatmentLinks } from "../calendar";

export default function ProblematicTreatment({ client }) {
  const links = getProblematicTreatmentLinks(client);

  if (links.length === 0) {
    return null;
  }

  return (
    <Tooltip
      title={links.map((l) => (
        <a
          key={l}
          href={l}
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-block",
          }}
        >
          {l}
        </a>
      ))}
    >
      <FontAwesomeIcon
        icon={faCircleExclamation}
        color="var(--mui-palette-warning-indicator)"
      />
    </Tooltip>
  );
}
